import { forwardRef, memo } from 'react';
import { useControl } from '../use-control';
import { RadioProps } from '../controls.types';
import { HiddenInput } from '../controls.styled';
import { StyledRadio } from './radio.styled';

export const Radio = memo(
  forwardRef<HTMLInputElement, RadioProps>((props, ref) => {
    const {
      checked: controlledChecked,
      onChange,
      onCheckedChange,
      disabled,
      size = 'm',
      style,
      ...restProps
    } = props;

    const { checked, handleChange, isControlled } = useControl(
      controlledChecked,
      onChange,
      onCheckedChange
    );

    return (
      <StyledRadio $size={size} style={style}>
        <HiddenInput
          {...restProps}
          type="radio"
          ref={ref}
          {...(isControlled ? { checked } : {})}
          onChange={handleChange}
          disabled={disabled}
        />

        <span className="radio-dot" />
      </StyledRadio>
    );
  })
);

Radio.displayName = 'Radio';
